export default (ngModule: ng.IModule) => {
  ngModule
    .config(mdThemingConfig)
    .config(httpInterceptors)
    .config(formConfig)
    .run(formTemplateCache);
};

/** @ngInject */
function mdThemingConfig($mdThemingProvider: angular.material.IThemingProvider) {
  $mdThemingProvider.theme('default')
    .primaryPalette('indigo')
    .accentPalette('light-green')
    .warnPalette('orange');
  //.backgroundPalette('light-green');
}

/** @ngInject */
function httpInterceptors($httpProvider: ng.IHttpProvider) {
  $httpProvider.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
  $httpProvider.interceptors.push(function () {
    return {request: request};
  });

  function request(config) {
    if (config.url.match(/\.php/) && typeof config.params === 'string') {
      config.url += '?' + config.params;
      config.params = {};
    }
    return config;
  }
}

const template = 'common/templates/form.html';

/** @ngInject */
function formConfig(ngFabFormProvider) {
  ngFabFormProvider.extendConfig({
    scrollToAndFocusFirstErrorOnSubmit: true,
    setNovalidate: true,
    validationsTemplate: template
  });
}

/** @ngInject */
function formTemplateCache($templateCache) {
  $templateCache.put(template, require('./common/templates/form.html'));
}



/** WEBPACK FOOTER **
 ** ./app.config.ts
 **/